import { render, staticRenderFns } from "./ScrollableTabs.vue?vue&type=template&id=bb4e44ce&"
import script from "./ScrollableTabs.vue?vue&type=script&lang=js&"
export * from "./ScrollableTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports